import ResponsiveImage from '../../templates/ResponsiveImage.jsx';
import Availability from '@bonprix/pattern-library/templates/availability';
import Button from '@bonprix/pattern-library/templates/button/default';
import ButtonWithIcon from '@bonprix/pattern-library/templates/button/with-icon';
import Url from '../../helper/url';
import ItemOptionSelection from './ItemOptionSelection.jsx';
import ItemSelection from './ItemSelection.jsx';
import QuantitySelection from './QuantitySelection.jsx';
import StyleSelection from './StyleSelection.jsx';
import React, {Fragment} from 'react';
import {Link, Typography} from "@bonprix/design-system";

export default function ChangeItemLayerContent({
                                                   texts,
                                                   product,
                                                   item,
                                                   onChangeQuantity,
                                                   selectedStyle,
                                                   selectedItem,
                                                   selectedItemOption,
                                                   layerOrigin,
                                                   channelId,
                                                   sizeError,
                                                   quantity,
                                                   submitError,
                                                   setSelectedItem,
                                                   setSelectedItemOption,
                                                   setIsItemOptionError,
                                                   setSelectedStyle,
                                                   setNotifiable
                                               }) {
    return (
        <>
            <a href={Url.toAbsolute(selectedItem.path)} className="change-item-layer__product-image">
                <ResponsiveImage alt={product.title} image={selectedItem.image} />
            </a>

            <div className="change-item-layer__details">
                <a href={Url.toAbsolute(selectedItem.path)} className="change-item-layer__article-link">
                    {product.title}
                </a>

                {selectedItemOption ? (
                    <>
                        <div className="change-item-layer__former-price">
                            {selectedItemOption.formattedFormerPrice}
                        </div>
                        <div
                            className={
                                'change-item-layer__price' +
                                (selectedItemOption.formattedFormerPrice ? ' -with-former-price' : '')
                            }
                        >
                            {selectedItemOption.formattedPrice}
                        </div>
                    </>
                ) : (
                    <>
                        <div className="change-item-layer__former-price">{selectedItem.formerPrice}</div>
                        <div
                            className={
                                'change-item-layer__price' +
                                (selectedItem.formerPrice ? ' -with-former-price' : '')
                            }
                        >
                            {selectedItem.price}
                        </div>
                    </>
                )}

                {selectedItemOption && (
                    <Availability
                        className={
                            'change-item-layer__availability -' + selectedItemOption.availabilityType
                        }
                    >
                        {selectedItemOption.availabilityStatus}
                    </Availability>
                )}
            </div>

            <div className="change-item-layer__selections">
                {/*This StyleSelection Component only renders when a 2D article is selected*/}
                <StyleSelection
                    styles={product.styles}
                    selectedItem={selectedItem}
                    headline={texts.ada_variante}
                    layerOrigin={layerOrigin}
                    hasStyleSelectOptions={product.styles.length > 1}
                    channelId={channelId}
                    item={item}
                    setSelectedStyle={setSelectedStyle}
                    setSelectedItem={setSelectedItem}
                    setSelectedItemOption={setSelectedItemOption}
                    setIsItemOptionError={setIsItemOptionError}
                />
                <ItemSelection
                    items={selectedStyle.items}
                    product={product}
                    selectedItem={selectedItem}
                    headline={texts.ada_label_farbe}
                    layerOrigin={layerOrigin}
                    channelId={channelId}
                    isSingleColor={selectedStyle.items.length === 1}
                    setSelectedItem={setSelectedItem}
                    selectedItemOption={selectedItemOption}
                    setSelectedItemOption={setSelectedItemOption}
                    setIsItemOptionError={setIsItemOptionError}
                />
                <ItemOptionSelection
                    label={texts.ada_matrix_groesse}
                    placeHolderText={texts.ada_choose_size}
                    options={selectedItem.itemOptions}
                    selectedItemOption={selectedItemOption}
                    isColli={product.coliItemsCount > 0}
                    isError={sizeError}
                    layerOrigin={layerOrigin}
                    channelId={channelId}
                    item={item}
                    product={product}
                    selectedItem={selectedItem}
                    setSelectedItemOption={setSelectedItemOption}
                    setNotifiable={setNotifiable}
                    setIsItemOptionError={setIsItemOptionError}
                />

                {quantity && (
                    <QuantitySelection
                        quantity={quantity}
                        texts={texts}
                        onChangeQuantity={onChangeQuantity}
                    />
                )}

                {submitError && (
                    <div className="change-item__submit-error">{texts.ada_add_to_cart_error}</div>
                )}
            </div>
        </>
    );
}
